import * as Yup from 'yup';
import { telephoneValidation, postcodeValidation } from 'utils/form/validation';

export const adviserDetailsSchema = Yup.object().shape({
  address: Yup.object().when('edit.address', {
    is: true,
    then: Yup.object().shape({
      flatNumber: Yup.string().typeError('Flat number is invalid'),
      buildingName: Yup.string().typeError('Building name is invalid'),
      buildingNumber: Yup.string().typeError('Building number is invalid'),
      street: Yup.string().typeError('Street is invalid'),
      city: Yup.string()
        .typeError('City is invalid')
        .required('City is required'),
      county: Yup.string().typeError('County is invalid'),
      postcode: postcodeValidation().required('Post Code is required.'),
    }),
  }),
  email: Yup.string()
    .email('Please provide correct email address.')
    .required('Email is required.'),
  phone: telephoneValidation().required('This field is required.'),
});
